import canvasResource from "../resources/CanvasResource";
import { BaseRepository } from "../../../../infrastructure/BaseRepository";

class CanvasRepository extends BaseRepository {
  constructor() {
    super(canvasResource)
  }
}

const canvasRepository = new CanvasRepository();

export default canvasRepository;


// WEBPACK FOOTER //
// ./src/app/modules/canvas/domain/repositories/CanvasRepository.ts